export default __webpack_public_path__ + "static/media/contact-us-small.fbfc5370.png";